'use strict';

var App = App || {};

// This will only add the shade if it is not a touch device.
// There are too many performance issues with tablets and phones to have this effect.
App.HomeShadeOver = function () {
  'use strict';

  var $body, $main, $HomeshadeOver, $pageCta, $shadeOverSlides, $slideImage, $slideTitle, $slidePageLink, bottomOfShade;

  var initialize = function initialize() {
    _start();
  };

  var _start = function _start() {
    $body = $('body');

    if ($body.hasClass("template-home")) _initShadeSlides();

    if ($body.hasClass('slide-over-shade-effect')) {
      _setVars();
      $body.addClass('shade-over-slides');
      $body.addClass('shade-over-body');
      _bindShadeAfterChangeEffects();
      _bindShadeBeforeChangeEfects();
      _bindSetShadePage();
      _bindShadeSlideUpButton();
    }
  };

  var _setVars = function _setVars() {
    $main = $('main.shade-under');
    $HomeshadeOver = $('.shade-over');
    $pageCta = $('.cta-contact');
    $shadeOverSlides = $('.shade-over-slides');
    $slideImage = $shadeOverSlides.find(".slide-image");
    $slideTitle = $shadeOverSlides.find(".slide-title");
    $slidePageLink = $shadeOverSlides.find(".slide-page-link");
    bottomOfShade = $HomeshadeOver.offset().top + $HomeshadeOver.height();
  };

  var _bindSetShadePage = function _bindSetShadePage() {
    if ($body.hasClass('slide-over-shade-effect')) {
      var contentHeight = $('main').height();

      $pageCta.css({ marginTop: contentHeight + 'px' });

      _bindShadeScroll();
      _bindShadeResize();
    }
  };

  var _bindShadeScroll = function _bindShadeScroll() {
    $(window).on('scroll', function () {
      var scrollPos = $(document).scrollTop(),
          bodyHasShadeClass = $body.hasClass('shade-over-body');

      if (scrollPos < bottomOfShade && !bodyHasShadeClass) {
        var contentHeight = $('main').height();

        $body.addClass('shade-over-body');
        $pageCta.css({ marginTop: contentHeight + 'px' });
      } else if (scrollPos > bottomOfShade && bodyHasShadeClass) {
        $body.removeClass('shade-over-body');
        $pageCta.css({ marginTop: 0 });
      }
    });
  };

  var _bindShadeResize = function _bindShadeResize() {
    // Re-set the height variable in case content shifted on resize
    $(window).on('resize', function () {
      bottomOfShade = $HomeshadeOver.offset().top + $HomeshadeOver.outerHeight(true);
    });
  };

  var _bindShadeSlideUpButton = function _bindShadeSlideUpButton() {
    $(document).on('click', '.js-shade-slide-up', function (e) {
      e.preventDefault();
      var y = $(window).scrollTop(),
          shadeHeight = $('.shade-over').height();
      $("html, body").velocity('scroll', {
        duration: 1000,
        offset: y + (shadeHeight + 10),
        easing: 'ease-in-out'
      });
    });
  };

  var _bindShadeAfterChangeEffects = function _bindShadeAfterChangeEffects() {
    $shadeOverSlides.on('afterChange', function (e, slick, currentSlide, nextSlide) {
      // See if we need to pass an argument here.
      _shadeSlideAfterChangeEfects();
    });
  };

  var _bindShadeBeforeChangeEfects = function _bindShadeBeforeChangeEfects() {
    $shadeOverSlides.on('beforeChange', function (e, slick, currentSlide, nextSlide) {
      _shadeSlideBeforeChangeEffects();
    });
  };

  var _initShadeSlides = function _initShadeSlides() {
    $('.shade-over-slides').slick({
      arrows: false,
      autoplay: true,
      autoplaySpeed: 4000,
      mobileFirst: true,
      pauseOnFocus: false,
      pauseOnHover: false,
      fade: true,
      speed: 3000,
      responsive: [{
        breakpoint: 641,
        settings: {
          dots: true
        }
      }]
    });
  };

  var _shadeSlideAfterChangeEfects = function _shadeSlideAfterChangeEfects() {
    // Clear all active effects
    // Add active effects classes to the contents of the current slide.

    $slideImage.addClass("vis");
    // Show title
    setTimeout(function () {
      $slideTitle.addClass("vis");
    }, 450);
    setTimeout(function () {
      $slidePageLink.addClass("vis");
    }, 700);
  };

  // Removes all of the visibility classes together before changing the slide.
  var _shadeSlideBeforeChangeEffects = function _shadeSlideBeforeChangeEffects() {
    $slideImage.removeClass("vis");
    $slideTitle.removeClass("vis");
    $slidePageLink.removeClass("vis");
  };

  return {
    initialize: initialize
  };
}();